
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const industries = [
  {
    id: 1,
    key: "telecommunications",
    image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d",
    link: "/telecom"
  },
  {
    id: 2,
    key: "inspections",
    image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866",
    link: "/inspections"
  },
  {
    id: 3,
    key: "checklists",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
    link: "/checklists"
  },
  {
    id: 4,
    key: "assetManagement",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158",
    link: "/asset-management"
  },
  {
    id: 5,
    key: "taskManagement",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
    link: "/task-management"
  },
  {
    id: 6,
    key: "slaManagement",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978",
    link: "/sla-management"
  },
  {
    id: 7,
    key: "barcodeScanning",
    image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866",
    link: "/barcode-scanning"
  },
  {
    id: 8,
    key: "manufacturing",
    image: "https://erpnext.com/files/production-plan-cover-small.jpeg",
    link: "/manufacturing"
  }
];

export const Industries = () => {
  const { t } = useTranslation();

  return (
    <section id="teams" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t('industries.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('industries.subtitle')}
          </p>
        </div>

        <div className="relative">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent className="-ml-2 md:-ml-4 pb-4">
              {industries.map((industry) => (
                <CarouselItem 
                  key={industry.id} 
                  className="pl-2 md:pl-4 basis-full md:basis-1/2 lg:basis-1/3"
                >
                  <Link to={industry.link} className="block">
                    <div className="bg-white rounded-lg shadow-lg overflow-hidden h-[400px] transition-all duration-300 hover:shadow-xl">
                      <div className="h-48 overflow-hidden relative group">
                        <div className="absolute inset-0 bg-[#0077bb]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        <img
                          src={industry.image}
                          alt={t(`industries.items.${industry.key}`)}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
                        />
                      </div>
                      <div className="p-6">
                        <h3 className="text-xl font-semibold text-gray-900 mb-3">
                          {t(`industries.items.${industry.key}`)}
                        </h3>
                      </div>
                    </div>
                  </Link>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="absolute -left-12 top-1/2" />
            <CarouselNext className="absolute -right-12 top-1/2" />
          </Carousel>
        </div>
      </div>
    </section>
  );
};
